import React from 'react';
import { Helmet } from 'react-helmet';

const Seo = ({ title, description, keywords, noindex = false }) => {    
    return (
        <Helmet>
            <title>{title} Hyundai Camiones & Buses</title>
            {description &&
                <meta name="description" content={description} />
            }
            {keywords &&
                <meta name="keywords" content={keywords} />
            }
            {noindex &&
                <meta name="robots" content="noindex" />
            }
        </Helmet>
    );
}

export default Seo;